module.exports = __webpack_public_path__ + "support.3310ae82c8a084c2483ce9ab382e68ce.svg";